/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CircularProgress } from "@material-ui/core";

import "./style.css";

import { getRequest, putRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from "../../translate/i18n";
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";
import format from "date-fns/format";
import exportExcel from "utils/exportExcel";
import { ImageLoader } from "components/ImageLoader";

export default function Company({ history }) {
  const [company, setCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [filter, setFilter] = useState("");
  const [onlyPending, setOnlyPending] = useState();
  const [onlyActive, setOnlyActive] = useState(true);

  const {
    selectedCompany,
    addSelectedCompany,
    handleUpdate,
    listOptionsCompanies,
  } = useNotification();
  const { toggleHelperId } = useModal();

  const getCompanies = async () => {
    setLoading(true);
    //BUSCA PERFIS DISPONIVEIS
    const ReturnGet = await getRequest(
      `/userscompanies/${selectedCompany.id}?onlyPending=${
        onlyPending ? "1" : "0"
      }&onlyActive=${onlyActive ? "1" : "0"}`
    );
    if (ReturnGet.success) {
      ReturnGet.data.forEach((data, index) => {
        if (data.active === true) {
          ReturnGet.data[index].active = i18n.t("userActive");
        } else if (data.active === false) {
          ReturnGet.data[index].active = i18n.t("inactive");
        }
        if (data.pending === true) {
          ReturnGet.data[index].pending = i18n.t("pending");
        } else if (data.pending === false) {
          ReturnGet.data[index].pending = i18n.t("approved");
        }
      });
      setCompany(ReturnGet.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanies();
    setGlobalFilter("");
  }, [update, onlyPending, onlyActive]);

  const handleExport = () => {
    let data = [];

    company.forEach((e) => {
      const company = {
        ID: e.id,
        SKUTE: e.partnerDescription,
        [i18n.t("name")]: e.name,
        [i18n.t("fantasy")]: e.nickName,
        [i18n.t("usersLimit")]: e.usersLimit
          ? e.usersLimit
          : i18n.t("dontHave"),
        [i18n.t("site")]: e.site,
        [i18n.t("phone")]: e.phone ? e.phone : i18n.t("dontHave"),
        [i18n.t("document")]: e.document,
        [i18n.t("zipCode")]: e.postalCode ? e.postalCode : i18n.t("dontHave"),
        [i18n.t("address")]: e.address ? e.address : i18n.t("dontHave"),
        [i18n.t("number")]: e.number ? e.number : i18n.t("dontHave"),
        [i18n.t("complement")]: e.complement
          ? e.complement
          : i18n.t("dontHave"),
        [i18n.t("city")]: e.city ? e.city : i18n.t("dontHave"),
        [i18n.t("state")]: e.state ? e.state : i18n.t("dontHave"),
        [i18n.t("status")]: e.active,
        Conta: e.trial ? "Trial" : "Paga",
        [i18n.t("responsible")]: e.responsibleName,
        [i18n.t("responsibleEmail")]: e.responsibleEmail,
        [i18n.t("responsiblePhone")]: e.responsibleCellPhone,
        [i18n.t("activeUntilThen")]: e.trialValidate
          ? format(new Date(e.trialValidate), "dd/MM/yyyy")
          : "Ilimitado",
        [i18n.t("validDate")]: e.dueDay,
        [i18n.t("createdAt")]: format(new Date(e.createdAt), "dd/MM/yyyy"),
      };
      data.push(company);
    });

    exportExcel(data, i18n.t("company"));
  };

  const getPendings = () => {
    setOnlyPending(!onlyPending);
  };

  const getActive = () => {
    setOnlyActive(!onlyActive);
  };

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t("attemption"),
      text: i18n.t("eraseCompany"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t("confirmEraseCompany"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: i18n.t("attemption"),
          text: i18n.t("putExclude"),
          icon: "warning",
          input: "text",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t("confirm"),
          preConfirm: (value) => {
            if (value.toUpperCase() !== "EXCLUIR") {
              Swal.showValidationMessage(
                `Você digitou excluir de forma incorreta`
              );
            }
          },
        }).then(async (result) => {
          //INATIVAR EMPRESA
          const ReturnPut = await putRequest(`/companies/inactivate/${id}`);
          if (ReturnPut.success) {
            if (id === selectedCompany.id) {
              addSelectedCompany({
                value: listOptionsCompanies[0].value,
                trial: listOptionsCompanies[0].trial,
                id: listOptionsCompanies[0].value,
                label: listOptionsCompanies[0].nickName,
                logo: listOptionsCompanies[0].pathLogo,
                trialLimit: listOptionsCompanies[0].trialValidate,
                usersLimit: listOptionsCompanies[0].usersLimit,
                dueDay: listOptionsCompanies[0].dueDay,
                ticketToShow: listOptionsCompanies[0].ticketShowData,
              });
            }
            handleUpdate(update + 1);
            setUpdate(update + 1);
          }
        });
      }
    });
  };

  const editCompany = (data) => {
    addSelectedCompany({
      value: data.id,
      id: data.id,
      label: data.nickName,
      trial: data.trial,
      logo: data.pathLogo,
      trialLimit: data.trialValidate,
      usersLimit: data.usersLimit,
      dueDay: data.dueDay,
      ticketToShow: data.ticketShowData,
    });
    // ZERA TEXTOS DO TICKETHISTORIES DO CONTEXT
    // addNotificationsText({});
    history.push(`../../dashboard/editcompany/${data.id}`);
  };

  const header = (
    <div className="data-table-header" style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          position: "absolute",
          left: 0,
        }}
      >
        <div className="checkbox-container" style={{ marginRight: 30 }}>
          <input
            checked={onlyPending}
            onChange={(e) => getPendings()}
            name="feedback"
            type="checkbox"
            className="checkbox"
            style={{ marginRight: 10 }}
          />
          <label>{i18n.t("onlyPending")}</label>
        </div>
        <div className="checkbox-container">
          <input
            checked={onlyActive}
            onChange={(e) => getActive()}
            name="feedback"
            type="checkbox"
            className="checkbox"
            style={{ marginRight: 10 }}
          />
          <label>{i18n.t("showInactive")}</label>
        </div>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        {data.active === "Ativo" && (
          <>
            <div
              className="action-icon"
              style={{ cursor: "pointer", marginRight: 10 }}
              onClick={() => editCompany(data)}
            >
              <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
            </div>
            <div
              className="action-icon"
              style={{ cursor: "pointer" }}
              onClick={() => handleInativate(data.id)}
            >
              <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
            </div>
          </>
        )}
      </div>
    );
  };

  const photoTemplate = (data) => {
    return (
      <ImageLoader
        alt={data.nickName}
        imgUrl={data.pathLogo}
        resourceType="company"
        style={{ maxWidth: 40 }}
        showTooltip
        label={data.nickName}
        whosCalling="Company 263"
      />
    );
  };

  useEffect(() => {
    if (filter.length < 3 && filter.length !== 0) {
      return;
    }
    const timeout = setTimeout(() => {
      setGlobalFilter(filter);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [filter]);

  useEffect(() => {
    toggleHelperId(3);
  }, []);

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="card">
        <div className="card-body pt-2">
          <div className="area-header-table-users">
            <h4>{i18n.t("config")}</h4>
            <button
              type="button"
              onClick={handleExport}
              className="export-excel"
            >
              <i
                style={{ fontSize: 16, marginRight: 5 }}
                className="pi pi-file-excel"
              />
              <span style={{ fontSize: "1vw" }}>{i18n.t("exportAllData")}</span>
            </button>
          </div>
          <div className="tab-content">
            <div className="tab-pane show active" id="basic-datatable-preview">
              {!loading ? (
                <DataTable
                  globalFilter={globalFilter}
                  header={header}
                  dataKey="id"
                  rowsPerPageOptions={[25, 50, 100]}
                  value={company}
                  paginator
                  rows={25}
                  emptyMessage={i18n.t("noCompanyRegistered")}
                >
                  <Column
                    body={photoTemplate}
                    field="photo"
                    header="Avatar"
                  ></Column>
                  <Column
                    field="nickName"
                    header={i18n.t("fantasy")}
                    sortable
                  ></Column>
                  <Column field="document" header={i18n.t("registry")}></Column>
                  <Column
                    field="partnerDescription"
                    header="SKUTE"
                    sortable
                  ></Column>
                  <Column
                    field="responsibleName"
                    header={i18n.t("responsible")}
                    sortable
                  ></Column>
                  <Column field="pending" header="Status" sortable></Column>
                  <Column
                    field="active"
                    header={i18n.t("userActive")}
                    sortable
                  ></Column>
                  <Column
                    body={actionButtonsTemplate}
                    field="action"
                    header={i18n.t("action")}
                  ></Column>
                </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <div
            className="button-add-relative"
            onClick={() => history.push(`../../../dashboard/newcompany`)}
          >
            <i className="mdi mdi-plus"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
